import { REMOVE_CURRENT_DRIVER_CARD_ON_MAP, SET_CURRENT_DRIVER_CARD_ON_MAP } from './available-drivers-map-actions';

const initialState = {
  currentDriver: null,
  currentDriverLat: null,
  currentDriverLng: null
};

function availableDriversMapReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_DRIVER_CARD_ON_MAP:
      return {
        currentDriver: action.payload.driver,
        currentDriverLat: action.payload.lat,
        currentDriverLng: action.payload.lng
      };
    case REMOVE_CURRENT_DRIVER_CARD_ON_MAP:
      return initialState;
    default:
      return state
  }
}

export default availableDriversMapReducer



// WEBPACK FOOTER //
// ./src/components/available-drivers-map/available-drivers-map-reducer.js